import { Container, Form, Button } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Errors from "components/Errors";
import Spin from "components/Spin";
import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import API, { baseUrl } from "utils/Axios";
import IngresoToken from "components/ingresoToken";
import IngresoContraseña from "components/ingresoContrasña";
import Password from "antd/lib/input/Password";
const RecuperarClave = () => {
  const [contador, setContador] = useState(0);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      datos: "", // Inicialmente vacío (correo)
      token: "", // Inicialmente vacío (token)
    },
    mode: "all",
    reValidateMode: "onChange",
    shouldFocusError: true,
  });
  const [cargando, setCargando] = useState(false);
  const [code, setCode] = useState("");

  const onFinish = async (data) => {
    try {
      setCargando(true);
      if (contador === 0) {
        const { data: respuesta } = await API.post('usuarios/usuarios/reset-password/', data)
        // const { data: respuesta } = await axios.post(
        //   "http://127.0.0.1:8000/api/usuarios/usuarios/reset-password/",
        //   data
        // );
        toast.success("Revise su correo electrónico y siga las instrucciones");
        reset();
        setContador(1);
      } else if (contador === 1) {
        const { data: respuesta } = await API.post("usuarios/usuarios/validacion-token/",data);
        // Asegúrate de enviar el token correctamente
        toast.success("Token validado con éxito");
        setContador(2);
      } else if (contador === 2) {
        let data_envio = { ...data, code: data, Password: code.password };
        
        const { data: respuesta } = await API.post(
          "usuarios/usuarios/cambio-password/",
          data_envio
        );
        toast.success("Contraseña cambiada con éxito");
        setTimeout(() => {
          window.location.href = "https://consultoriojuridico.uniatlantico.edu.co/login/";
        }, 750);
      }
  
      setCargando(false);
    } catch (error) {
      console.log(error.response);
      setCargando(false);
      console.log('error.response.data =>> ',error.response.data)
      if (error.response) {
        if(error.response.data.error){
         toast.error(error.response.data.error);

        } else if (error.response.data.data) {
          toast.error(error.response.data.data);  // Si no tiene la estructura esperada

        } else if (error.response.data) {
          toast.error(error.response.data);  // Si no tiene la estructura esperada

        } else {
          toast.error("Error desconocido");  // Si no hay data en la respuesta
        }
      } else {
        toast.error("Error al conectar con el servidor");  // Si no hay respuesta del servidor
      }
    }
  };
  
  const getButtonText = () => {
    if (contador === 0) return "Enviar correo de recuperación";
    if (contador === 1) return "Validar token";
    if (contador === 2) return "Cambiar contraseña";
    return "volver al inicio";
  };

  return (
    <>
      <Spin cargando={cargando}>
        <Container className="d-flex justify-content-center align-items-center">
          <Form
            noValidate
            onSubmit={handleSubmit(onFinish)}
            style={{ width: "60%", marginTop: 100, marginBottom: 32 }}
          >
            <img
              src="/images/logo.png"
              className="img-fluid"
              style={{ marginBottom: 100 }}
            />
            {contador == 0 && (
              <Controller
                name={"datos"}
                control={control}
                defaultValue=""
                rules={{ required: "Ingrese su correo" }}
                render={({ field }) => (
                  <Form.Group>
                    <>
                      <Form.Label>Correo electrónico</Form.Label>
                      <Form.Control {...field} />
                      <Errors message={errors.correo?.message} />
                    </>
                  </Form.Group>
                )}
              />
            )}

            {contador == 1 && (
              <IngresoToken errors={errors} control={control} />
            )}
            {contador == 2 && (
              <IngresoContraseña errors={errors} control={control} />
            )}

            <Button type="primary" variant="primary" className="btn-block">
              {getButtonText()}
            </Button>
          </Form>
        </Container>
      </Spin>
    </>
  );
};

export default RecuperarClave;
